import { render, staticRenderFns } from "./ui-tooltip-icon.vue?vue&type=template&id=6ecabe2c&"
import script from "./ui-tooltip-icon.vue?vue&type=script&lang=ts&"
export * from "./ui-tooltip-icon.vue?vue&type=script&lang=ts&"
import style0 from "./ui-tooltip-icon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports